export enum EStorage {
    CONTRACT_TEMP = `registrauto_contract_temp`
}
